// api
import { createBasketClient } from "../../../api/clientFactory";
import * as Client from "../../../api/Client";
import { call } from "../../../api/callHelper";
// me
import { IRootViewModel } from "./models/models";
import { download } from "../../../common/documentHelper";

export async function initialiseSubmit(updateVm: React.Dispatch<React.SetStateAction<IRootViewModel>>): Promise<void> {
    updateVm((vm) => vm.referenceDataLoading());

    const client = createBasketClient();
    const request = new Client.GetSubmitPublicNopimsBasketReferenceDataRequestDto();
    const result = await call(() => client.getSubmitPublicNopimsBasketReferenceData(request));

    updateVm((vm) => vm.referenceDataLoaded(result.Response, result.Error));
}

export async function submitBasket(userToken: string, vm: IRootViewModel, updateVm: React.Dispatch<React.SetStateAction<IRootViewModel>>): Promise<void> {
    updateVm((vm) => vm.basketSubmitting());

    const client = createBasketClient();
    const request = new Client.SubmitPublicNopimsBasketRequestDto({
        userToken: userToken,
        honorificId: vm.customerDetails.honorific?.id,
        firstName: vm.customerDetails.firstName!,
        lastName: vm.customerDetails.lastName!,
        contactNumber: vm.customerDetails.contactNumber!,
        email: vm.customerDetails.emailAddress!,
        companyName: vm.customerDetails.companyName,
        address: vm.customerDetails.address!,
        suburb: vm.customerDetails.suburb!,
        postcode: vm.customerDetails.postcode,
        countrySubdivisionId: vm.customerDetails.countrySubdivision?.id,
        countryId: vm.customerDetails.country!.id,
        comments: vm.customerDetails.comments!,
    });
    const result = await call(() => client.submitPublicNopimsBasket(request));

    updateVm((vm) => vm.basketSubmitted(result.Response, result.Error));
}

export async function exportBasket(userToken: string, updateVm: React.Dispatch<React.SetStateAction<IRootViewModel>>): Promise<void> {
    updateVm((vm) => vm.basketExporting());

    const client = createBasketClient();
    const request = new Client.ExportPublicNopimsBasketRequestDto({ userToken: userToken });
    const result = await call(() => client.exportPublicNopimsBasket(request));

    if (!result.Error) {
        const response = result.Response!;
        download(response.fileName, response.mimeType, response.content);
    }

    updateVm((vm) => vm.basketExported(result.Error));
}
